module.exports = __webpack_public_path__ + "static/devsum-397c18f6e11dd866a50ae26b004b0ed9.jpg";